<script setup lang="ts">
import DispositionFahrer from "./DispositionFahrer.vue";

interface IFahrer {
  id: string;
  name: string;
  ist_informiert: boolean;
  hat_dokumente: boolean;
}

defineProps<{
  fahrer: IFahrer[];
}>();
</script>

<template>
  <template v-for="f in fahrer" :key="f.id">
    <DispositionFahrer
      :name="f.name"
      :ist-informiert="f.ist_informiert"
      :hat-dokumente="f.hat_dokumente"
    />
    <span class="mx-1.5 last:hidden">|</span>
  </template>
  <template v-if="fahrer.length === 0">
    <span class="inline-block w-3 h-3 bg-red-600 rounded-full"></span>
  </template>
</template>
